module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game"
  }, [_c('app-header', {
    attrs: {
      "phase": _vm.game.phase,
      "round": _vm.game.round,
      "player": _vm.game.players[_vm.game.turnIndex],
      "canTurnInCards": _vm.game.canTurnInCards,
      "attackLine": _vm.attackLine,
      "canCancel": _vm.passData.canCancel,
      "menu": _vm.buttonRouter,
      "paused": _vm.aiPaused
    }
  }), _vm._v(" "), _c('board', {
    attrs: {
      "territories": _vm.game.territories,
      "players": _vm.game.players
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('invasion-map', {
    attrs: {
      "clicker": _vm.clicker
    }
  })], 1), _vm._v(" "), _c('popup', {
    attrs: {
      "show": _vm.popup.show,
      "closePopup": _vm.closePopup,
      "action": _vm.popup.action,
      "size": _vm.popup.size,
      "type": _vm.popup.type,
      "title": _vm.popup.title,
      "content": _vm.popup.content,
      "data": _vm.popup.data,
      "repeatAttack": _vm.repeatAttack
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "show": _vm.alert.show,
      "placement": "top-right",
      "type": "success",
      "dismissable": true,
      "width": "200px",
      "duration": 1500,
      "close": _vm.closeAlert
    }
  }, [_vm._v(_vm._s(_vm.alert.content))]), _vm._v(" "), _c('app-footer', {
    attrs: {
      "phase": _vm.game.phase,
      "terr": _vm.selected
    }
  }), _vm._v(" "), _c('AIplayer', {
    attrs: {
      "computerAttack": _vm.computerAttack,
      "computerEndTurn": _vm.computerEndTurn,
      "trigger": _vm.aiTrigger,
      "paused": _vm.aiPaused
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-691b32c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/game.vue
// module id = 200
// module chunks = 0